import { invoiceStatus } from ".";
import { Doc } from "../../_generated/dataModel";
import { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

// Filtra facturas por status (draft, issued, partial, paid, cancelled, overdue).
export const invoiceStatusRule: FilterRule<Doc<"invoices">> = {
  priority: 1,
  build: async (ctx: FilterRuleCtx, args: Partial<Omit<Doc<"invoices">, "_id" | "_creationTime">>) => {
    const { userContext } = ctx;
    const status: Doc<"invoices">["status"] | undefined = args.status;

    if (!status) return undefined;
    const valid = [invoiceStatus.type] as const;
    if (!valid.includes(status as any)) return undefined;
    if (!userContext?.companyId) {
      throw new Error("Usuario no tiene empresa asignada");
    }

    return ctx.db
      .query("invoices")
      .withIndex("by_company_and_status", (q) =>
        q
          .eq("internalControl.companyId", userContext.companyId!)
          .eq("status", status),
      )
      .collect();
  },
};
